import React from "react";

/**
 * Lightweight animated SVG fallback for mobile / reduced-motion.
 * No WebGL. GPU-friendly. Same visual language as the 3D hero.
 */
export default function LandingHero2D() {
  return (
    <div className="relative w-full h-full flex items-center justify-center overflow-hidden">
      <svg viewBox="-200 -160 400 320" className="w-full h-full max-w-md" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="lh-core" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0%" stopColor="#93C5FD" stopOpacity="1"/>
            <stop offset="55%" stopColor="#3B82F6" stopOpacity="0.9"/>
            <stop offset="100%" stopColor="#1E3A8A" stopOpacity="0.6"/>
          </radialGradient>
          <radialGradient id="lh-glow" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0%" stopColor="#3B82F6" stopOpacity="0.55"/>
            <stop offset="100%" stopColor="#3B82F6" stopOpacity="0"/>
          </radialGradient>
        </defs>

        <circle cx="0" cy="0" r="140" fill="url(#lh-glow)"/>

        {/* Rings */}
        <g opacity="0.4">
          <ellipse cx="0" cy="0" rx="130" ry="60" fill="none" stroke="#3B82F6" strokeWidth="1"/>
          <ellipse cx="0" cy="0" rx="105" ry="46" fill="none" stroke="#22D3EE" strokeWidth="1">
            <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="18s" repeatCount="indefinite"/>
          </ellipse>
          <ellipse cx="0" cy="0" rx="80" ry="34" fill="none" stroke="#93C5FD" strokeWidth="1">
            <animateTransform attributeName="transform" type="rotate" from="360" to="0" dur="14s" repeatCount="indefinite"/>
          </ellipse>
        </g>

        {/* Core orb */}
        <circle cx="0" cy="0" r="42" fill="url(#lh-core)"/>
        <circle cx="0" cy="0" r="42" fill="none" stroke="#93C5FD" strokeOpacity="0.35" strokeWidth="1"/>

        {/* Orbiting nodes */}
        <g>
          <circle r="6" fill="#3B82F6">
            <animateMotion path="M 0 -60 A 60 60 0 1 1 0 60 A 60 60 0 1 1 0 -60" dur="7s" repeatCount="indefinite"/>
          </circle>
          <circle r="5" fill="#22D3EE">
            <animateMotion path="M 0 -95 A 95 42 0 1 1 0 95 A 95 42 0 1 1 0 -95" dur="10s" repeatCount="indefinite"/>
          </circle>
          <circle r="4" fill="#10B981">
            <animateMotion path="M 0 -120 A 120 55 0 1 0 0 120 A 120 55 0 1 0 0 -120" dur="14s" repeatCount="indefinite"/>
          </circle>
        </g>

        {/* Floating cards */}
        <g transform="translate(-140,-100)" opacity="0.9">
          <rect width="72" height="44" rx="6" fill="#0B1220" stroke="#3B82F6" strokeOpacity="0.35"/>
          <rect x="6" y="8" width="40" height="4" rx="2" fill="#3B82F6"/>
          <rect x="6" y="18" width="52" height="3" rx="1.5" fill="#475569"/>
          <rect x="6" y="26" width="34" height="3" rx="1.5" fill="#334155"/>
          <animateTransform attributeName="transform" type="translate" values="-140,-100; -136,-96; -140,-100" dur="6s" repeatCount="indefinite"/>
        </g>
        <g transform="translate(80,60)" opacity="0.9">
          <rect width="80" height="48" rx="6" fill="#0B1220" stroke="#22D3EE" strokeOpacity="0.35"/>
          <rect x="6" y="8" width="45" height="4" rx="2" fill="#22D3EE"/>
          <rect x="6" y="18" width="58" height="3" rx="1.5" fill="#475569"/>
          <rect x="6" y="26" width="30" height="3" rx="1.5" fill="#334155"/>
          <animateTransform attributeName="transform" type="translate" values="80,60; 76,64; 80,60" dur="7s" repeatCount="indefinite"/>
        </g>
        <g transform="translate(110,-110)" opacity="0.85">
          <rect width="66" height="40" rx="6" fill="#0B1220" stroke="#10B981" strokeOpacity="0.35"/>
          <rect x="6" y="8" width="36" height="4" rx="2" fill="#10B981"/>
          <rect x="6" y="18" width="48" height="3" rx="1.5" fill="#475569"/>
          <animateTransform attributeName="transform" type="translate" values="110,-110; 114,-114; 110,-110" dur="8s" repeatCount="indefinite"/>
        </g>
      </svg>
    </div>
  );
}
